package org.moxultimate.topwithmox.statics

/**
 * AboutStatics
 * Central registry for all static strings and content data used on the /about page.
 * Change text content here instead of hunting across composable files.
 */
object AboutStatics {

//----- Hero Section ---------------------------------------------------------------------------------------------------

    const val SUBTITLE       = "ABOUT · TOP WITH MOX"
    const val HERO_TITLE_1   = "The Top Of"
    const val HERO_TITLE_2   = "Everything Digital"
    const val HERO_TAGLINE   =
        "Behind the reviews, there's a team obsessed with the best — " +
                "bringing you the top of everything digital."

//----- Vision Section -------------------------------------------------------------------------------------------------

    const val VISION_TITLE = "Our Vision"
    const val VISION_DESC  =
        "We believe everyone deserves access to the best of everything digital. " +
                "TopWithMox is your ultimate guide — whether you're hunting for the perfect wallpaper, " +
                "the top-rated tech product, your next binge-watch, or a guide that actually works."

    const val CONTENTS_TITLE = "What We Cover"

    // Content pillars — each entry is (emoji, title, description)
    val CONTENT_PILLARS = listOf(
        Triple("🖼️", "Wallpapers",    "4K · 8K curated wallpapers for every screen, free forever."),
        Triple("🎮", "Products",      "Honest reviews and rankings of the latest tech gear."),
        Triple("🎬", "Shows & Anime", "Your guide to the best shows, movies, and anime right now."),
        Triple("💡", "Tech & Guides", "Tutorials, how-to's, and productivity tips that actually work."),
        Triple("📱", "Apps & Games",  "Top game and app picks for every platform and every need."),
    )

//----- Mox & Team Section ---------------------------------------------------------------------------------------------

    const val MOX_TITLE      = "Meet Mox"

    /**
     * MOX_GALLERY_IMAGES
     * Placeholder image paths for the Meet Mox section carousel.
     * Replace each empty string with a real image path (e.g. "/mox_photo_1.webp") when ready.
     */
    val MOX_GALLERY_IMAGES = listOf(
        "",  // placeholder 1 — replace with real photo path
        "",  // placeholder 2 — replace with real photo path
        "",  // placeholder 3 — replace with real photo path
        "",  // placeholder 4 — replace with real photo path
        "",  // placeholder 5 — replace with real photo path
        "",  // placeholder 6 — replace with real photo path
        "",  // placeholder 7 — replace with real photo path
        "",  // placeholder 8 — replace with real photo path
    )
    const val MOX_DESC       =
        "Mox is a tech enthusiast, content creator, and honest reviewer dedicated to finding " +
                "the very best of everything digital. From gadgets and wallpapers to shows and " +
                "productivity guides — every review is hands-on and every recommendation is real."
    const val TEAM_TAGLINE   = "Small team. Big passion. Relentless standards."

//----- Connect Section ------------------------------------------------------------------------------------------------

    const val CONNECT_TITLE   = "Connect With Us"
    const val CONNECT_DESC    =
        "Follow us on social, drop a message, or just say hi — we'd love to hear from you."
    const val EMAIL_LABEL     = "EMAIL US"
    const val EMAIL_ADDRESS   = "topwithmox@gmail.com"
    const val EMAIL_LINK      = "mailto:topwithmox@gmail.com"

//----- Social Links ---------------------------------------------------------------------------------------------------

    const val SOCIAL_FACEBOOK_ICON  = "/ic_facebook.png"
    const val SOCIAL_FACEBOOK_LINK  = "https://www.facebook.com/topwithmox"
    const val SOCIAL_INSTAGRAM_ICON = "/ic_instagram.png"
    const val SOCIAL_INSTAGRAM_LINK = ""
    const val SOCIAL_YOUTUBE_ICON   = "/ic_youtube.png"
    const val SOCIAL_YOUTUBE_LINK   = "https://www.youtube.com/@TopWithMox/videos"
    const val SOCIAL_TIKTOK_ICON    = "/ic_tiktok.png"
    const val SOCIAL_TIKTOK_LINK    = "https://www.tiktok.com/@topwithmox"
    const val SOCIAL_EMAIL_ICON     = "/ic_google.png"
    const val SOCIAL_MAIL_ICON      = "/ic_mail.png"

//----- Shared Assets --------------------------------------------------------------------------------------------------

    const val IMG_WOOD_TOP    = "/img_curved_wood_top.webp"
    const val IMG_WOOD_BOTTOM = "/img_curved_wood_bottom.webp"

}
